import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.POSITION_DEVICES].GET_POSITION_DEVICES]: {
		url: '/company/:companyId/positions/devices/',
	},
	[ModulesConfigMap[ModulesMap.POSITION_DEVICES].GET_POSITION_DEVICE]: {
		url: '/company/:companyId/positions/devices/:deviceId/',
	},
}